import { FooterText } from "./style";

export const FooterLink = ({ question, link, onClick }) => {
  return (
    <FooterText>
      {question}? <span onClick={onClick}>{link}</span>
    </FooterText>
  );
};
